
import { mapActions, mapGetters } from 'vuex';

import commonMixin from '@/mixins/templates/common';
import moveTo from '@/components/content-v2/modals/move-to';
import { ABtn } from '@maisaedu/ui-components-a-btn';

const CREATE_GROUPER = 1;
const MOVE_TO_GROUPER = 2;


export default {
  mixins     : [commonMixin],
  components : {
    moveTo,
    ABtn
  },
  props: {
    moduleGroups: {
      type    : Array,
      default : () => []
    },
    topic: {
      type    : Object,
      default : () => ({})
    },
    isOpen: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      optionMarked: null,
      options:
        [
          { id: CREATE_GROUPER, text: this.$t('contentMigration.text.createGrouper') },
          { id: MOVE_TO_GROUPER, text: this.$t('contentMigration.text.moveToGroup') }
        ],
      moveModalOptions: {
        isOpen    : false,
        isLoading : false
      },
      isDisabled: true
    };
  },
  computed: {
    ...mapGetters({
      getterContent: 'plataforma/newContent/getterContent'
    }),
    getContext() {
      return this.$route.params.id ? this.getterContent.context : this.getterCourse.context;
    },
    topics() {
      return this.moduleGroups.filter((topic) => topic.id !== (topic.children && topic.children[0] && topic.children[0].id));
    }
  },
  methods: {
    ...mapActions({
      actionPatchMoveToTopic : 'plataforma/newContent/actionPatchMoveToTopic',
      actionGroupTopic       : 'plataforma/newContent/actionGroupTopic'
    }),
    cancel() {
      this.$emit('close');
      this.optionMarked = null;
    },
    closeMoveTo() {
      this.moveModalOptions.isOpen = false;
    },
    handleConfirmAdjust() {
      if (this.optionMarked === CREATE_GROUPER) {
        this.$nuxt.$loading.start();

        const params = {
          topicId        : this.topic.id,
          academicMainId : this.$route.params.courseId
        };

        this.actionGroupTopic(params)
          .then(() => {
            this.cancel();
            this.$toast.success(this.$t('content.successMessagesSnackbar.createGroupModule'));

          }).catch((err) => {
            this.$toast.error(err.message);
          }).finally(() => {
            this.$nuxt.$loading.finish();
          });
      } else {
        this.moveModalOptions.isOpen = true;
      }

    },
    moveTo(newParentTopic) {
      const params = {
        academicMainId   : this.$route.params.courseId,
        newParentTopicId : newParentTopic && newParentTopic.id ? newParentTopic.id : null,
        topic            : this.topic,
        version          : this.getContext.version
      };

      this.moveModalOptions.isLoading = true;

      this.actionPatchMoveToTopic(params)
        .then(() => {
          this.closeMoveTo();
          this.cancel();

          this.$toast.success(this.$t('content.modalMoveTo.itemMovedSuccessfully'));
        }).catch((err) => {
          this.$toast.error(err.data.error.message);
        }).finally(() => {
          this.moveModalOptions.isLoading = false;
        });
    }
  }
};
